import React from 'react';
import { Zap, Lock, ShieldCheck, Shield } from 'lucide-react';
import { trackEvent } from '../hooks/useMetaPixel';
export function Hero() {
  return <section id="hero" className="relative flex flex-col items-center justify-center text-center px-4 sm:px-6 pt-12 sm:pt-16 pb-10 sm:pb-14 min-h-[85vh] sm:min-h-screen" style={{
    backgroundImage: `url('https://i.postimg.cc/k4MFMQN0/PI-9PJzs-RXq7-gp-GSpz-SH-min.webp'), linear-gradient(135deg, #0a0a0a 0%, #1a1208 100%)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat'
  }} data-id="element-219">
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/85" data-id="element-220" />

      <div className="relative z-10 max-w-[860px] animate-fade-up" data-id="element-221">
        <img src="https://i.postimg.cc/434FGjc3/LOGO-2.png" alt="Pasta Sin Gluten" className="h-[70px] w-auto object-contain mx-auto mb-8" data-id="element-222" />

        <p className="text-[12px] tracking-[4px] uppercase text-oro mb-5 font-semibold flex items-center justify-center gap-2" data-id="element-223">
          <span className="w-1.5 h-1.5 rounded-full bg-oro" data-id="element-224"></span>
          El Método Italiano™ — Hugo Otero
        </p>

        <h1 className="font-playfair text-[clamp(32px,6vw,68px)] font-bold leading-[1.1] mb-6 text-white" data-id="element-225">
          Finalmente, pasta que sabe
          <br data-id="element-226" />
          <em className="italic text-oro-claro" data-id="element-227">como Dios manda</em>
          <br data-id="element-228" />
          sin una miga de gluten.
        </h1>

        <p className="text-[clamp(15px,2.2vw,19px)] text-white/80 max-w-[640px] mx-auto mb-9 leading-[1.7]" data-id="element-229">
          Si llevas meses comiendo pasta blanda, sin sabor y cara, esto es para
          ti. Descubre el sistema que usan los chefs italianos para hacer pasta
          sin gluten que nadie nota que es diferente.
        </p>

        <div className="inline-flex flex-wrap items-center justify-center gap-3 sm:gap-4 bg-white/5 border border-oro/30 rounded-md px-5 sm:px-7 py-3 sm:py-3.5 mb-7" data-id="element-230">
          <span className="text-[16px] sm:text-[18px] text-white/40 line-through" data-id="element-231">
            USD $120
          </span>
          <span className="font-montserrat text-[32px] sm:text-[40px] font-black text-oro-claro" data-id="element-232">
            USD $12
          </span>
          <span className="bg-rojo-acento text-white text-[11px] font-extrabold tracking-[1px] px-2.5 py-1 rounded-sm" data-id="element-233">
            90% OFF
          </span>
        </div>

        <br data-id="element-234" />

        <a href="#cta-final" onClick={e => {
        e.preventDefault();
        trackEvent('InitiateCheckout', {
          content_name: 'Hero CTA',
          value: 12,
          currency: 'USD'
        });
        document.getElementById('cta-final')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="btn-cta inline-flex items-center justify-center gap-2" data-id="element-235">
          <Zap size={18} className="fill-current" data-id="element-236" /> Obtener Acceso Inmediato
        </a>

        <div className="flex flex-wrap justify-center items-center gap-6 mt-4" data-id="element-237">
          <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-238">
            <Lock size={13} className="text-oro" data-id="element-239" /> Compra 100% Segura
          </span>
          <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-240">
            <ShieldCheck size={13} className="text-oro" data-id="element-241" /> Garantía 7 días
          </span>
          <span className="text-[12px] text-white/60 flex items-center gap-1.5" data-id="element-242">
            <Shield size={13} className="text-oro" data-id="element-243" /> Privacidad Protegida
          </span>
        </div>

        <div className="inline-flex items-center gap-2 bg-oro/10 border border-oro/40 rounded-sm px-3.5 py-1.5 text-[12px] text-oro-claro font-semibold tracking-[1px] mt-5" data-id="element-244">
          <span className="text-[11px] font-bold" data-id="element-245">TM</span> El Método Italiano™
          — Sistema en 3 etapas
        </div>
      </div>
    </section>;
}